import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=f18fb1c2&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=f18fb1c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f18fb1c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f18fb1c2')) {
      api.createRecord('f18fb1c2', component.options)
    } else {
      api.reload('f18fb1c2', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=f18fb1c2&scoped=true&", function () {
      api.rerender('f18fb1c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2AQ1ZkEFOiA1p/JS/comp/PopupBox.vue"
export default component.exports